import { useState } from "react";

/**
 * Renders the official VOIHU primary logo (`/public/voihu-primary.webp`).
 * Falls back to the plain wordmark only if the image itself fails to load.
 */
const LOGO_SRC = "/voihu-primary.webp";

export default function VoihuMark({ testid = "voihu-mark" }) {
  const [failed, setFailed] = useState(false);
  if (failed) {
    return <span className="oh-label" data-testid={testid}>VOIHU</span>;
  }
  return (
    <img
      src={LOGO_SRC}
      alt="VOIHU"
      onError={() => setFailed(true)}
      className="h-16 sm:h-20 w-auto block select-none"
      draggable={false}
      data-testid={testid}
    />
  );
}
